function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.908 10.724a.405.405 0 01-.398-.414V7.414c0-.229.178-.414.398-.414.22 0 .397.185.397.414v2.896a.406.406 0 01-.397.414z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.106 13.276c-3.902 0-7.083 3.243-7.207 7.276H1.724a.724.724 0 100 1.448h26.764a.724.724 0 000-1.448h-6.175c-.124-4.033-3.305-7.276-7.207-7.276zm0 1.655c3.026 0 5.495 2.5 5.618 5.62H9.489c.123-3.12 2.591-5.62 5.617-5.62z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.48 11.351a.39.39 0 00.52.224.42.42 0 00.214-.54L10.15 8.357a.392.392 0 00-.52-.224.42.42 0 00-.214.541l1.064 2.676zM7.42 14.04a.389.389 0 01-.28-.122L5.173 11.87a.427.427 0 010-.585.387.387 0 01.562 0l1.967 2.048a.426.426 0 010 .585.389.389 0 01-.281.122zM4.996 17.621c.05.022.101.032.152.032a.398.398 0 00.367-.256.42.42 0 00-.215-.54l-2.57-1.108a.39.39 0 00-.518.223.42.42 0 00.215.54l2.569 1.11zM18.982 11.527a.38.38 0 01-.152-.031.42.42 0 01-.215-.54l1.064-2.677a.392.392 0 01.52-.224c.202.088.299.33.214.54l-1.064 2.677a.397.397 0 01-.367.255zM22.446 12.342a.5.5 0 00-.001.694l.269.28a.5.5 0 00.721 0l2.446-2.548v6.873a.5.5 0 00.5.5h.349a.5.5 0 00.5-.5v-6.872l2.457 2.546a.5.5 0 00.723-.003l.261-.276a.5.5 0 00-.003-.691L26.915 8.46a.5.5 0 00-.719 0l-3.75 3.881z",
  fill: "currentColor"
})));